import { ValidatorInterface } from "../validator-interface";

export class IntegerOnlyValidator extends ValidatorInterface {
    getZodSchema(baseSchema, options = {}) {
        const message = options.message || "Please enter a valid integer";
        // options.value will be the value provided in data-zod-rules="myCustomRule=someValue"
        // options.message is the custom message if provided
        // options.labelText is the determined label for the field
        return baseSchema.refine(
            val => {
                return Number.isInteger(val);
            },
            { message }
        );
    }

    getErrorMessage(field, options = {}) {
        // This is typically used by validateExternal if it sets an error
        // Zod refinements usually define their message directly
        return options.message || "Please enter a valid Integer";
    }
}
